// app/components/Plugins/Automations/core/index.ts

/**
 * Core module exports for the Automations plugin
 * This file exports all the protocol implementations
 */

// Export protocol interfaces
export * from './protocols';

// Export base implementations
export { BaseNode } from './BaseNode';
export { FlowEngine } from './FlowEngine';
export { ExecutionEngine } from './ExecutionEngine';
export { DataProvider } from './DataProvider';
export { NodeFactory } from './NodeFactory';